module.exports = __webpack_public_path__ + "static/media/imgop_UoMLogo.802ebde4.webp";